export default __webpack_public_path__ + "static/media/86.78113fa4.png";